<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <h4 class="card-title">All Countries</h4>
                            </div>
                            <div class="col-md-10 text-right">
                                <b-button v-b-modal.modal-center variant="success">
                                    <i class="ri-add-line  align-middle mr-2"></i> Add region
                                </b-button>
                                <b-modal
                                        id="modal-center"
                                        centered
                                        title="Region "
                                        title-class="font-18"
                                        ref="my-modal"
                                        hide-footer
                                >
                                    <form @submit.prevent="createRegion">
                                        <div class="form-group">

                                            <label > Region</label>
                                            <input
                                                    v-model="name"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Name"
                                            />
                                        </div>
                                        <button
                                                class="btn btn-primary w-md waves-effect waves-light mt-4"
                                                type="submit"
                                        >Save</button>
                                    </form>

                                </b-modal>
                                <b-modal
                                        id="modal-delete"
                                        centered
                                        title="Update Region"
                                        title-class="font-18"
                                        ref="modal-delete"
                                        hide-footer
                                >
                                    <form @submit.prevent="updateRegion">
                                        <div class="form-group">
                                            <label > Region</label>
                                            <input v-if="selectedID"
                                                    v-model="selectedID.name"
                                                    type="text"
                                                    class="form-control"
                                            />
                                        </div>
                                        <div style="display: flex; justify-content: flex-end">
                                            <button
                                                class="btn btn-primary w-md waves-effect waves-light mt-4"
                                                type="submit"
                                            >Save</button>
                                        </div>
                                        
                                    </form>

                                </b-modal>
                            </div>

                        </div>

                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :items="regionData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    @filtered="onFiltered"
                            >

                                <template v-slot:cell(actions)="{item}">
                                    <!--                                    <div class="row justify-content-end">-->
                                    <!-- <b-button v-b-tooltip.hover title="Delete" class="actionBut" v-b-modal.modal-delete @click="choosenID(item)" variant="danger">
                                        <i class="ri-delete-bin-2-fill align-middle "></i>
                                    </b-button> -->
                                    <b-button class="actionBut" v-b-tooltip.hover v-b-modal.modal-delete title="Edit" variant="success" @click="choosenID(item)">
                                        <i class="ri-edit-fill align-middle "></i>
                                    </b-button>
                                    <!--                                    </div>-->
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>

</template>

<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import {axios_get, axios_post, axios_put} from "../../../helpers/helper";


    /**
     * Advanced table component
     */
    export default {
        page: {
            title: "View Regions",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, PageHeader },
        data() {
            return {
                reg:[],
                countries:null,
                regionData: [],
                selectedID:null,
                name:null,
                title: "View supported regions",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "View regions",
                        active: true
                    }
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "",
                sortDesc: false,
                fields: [
                   // { key: "country_id", sortable: true },
                    { key: "name", sortable: true },
                    { key: "actions", sortable: false }
                ],
                value:null,

                region:"",
                country_id:null,
            };
        },
        computed: {
            /**
             * Total no. of records
             */
            rows() {
                return this.regionData.length;
            }
        },
        mounted(){
            // Set the initial number of items
            this.totalRows = this.items.length;
            axios_get("/regions",{},(d)=>{
                    this.regionData=d.filter(e=>{return e.country_id==this.country_id})
                    this.regionData=this.regionData.sort((a, b)=>{
                        if(a.name <= b.name) return -1
                        else return 1;
                    })
                    console.log(this.regionData)
                },(e)=>{
                    console.log("error",e);
                },()=>{
                    console.log("finishing");
                }
            );
            this.countries=JSON.parse(localStorage.getItem('user'))
                console.log(this.countries.country_id)
            this.country_id=this.countries.country_id
        },
        methods: {
            selectedRegion(name){
                this.name=name
            },
            createRegion(){
                axios_post("/regions",{
                    name:this.name,
                    country_id:this.country_id,
                },(d)=>{
                    this.$refs['my-modal'].hide()
                    axios_get("/regions",{},(d)=>{
                        this.regionData=d.filter(e=>{return e.country_id==this.country_id})
                            this.regionData=this.regionData.sort((a, b)=>{
                                if(a.name < b.name) return -1;
                                else return 1;
                            })
                        },(e)=>{
                            console.log("error",e);
                        },()=>{
                            console.log("finishing");
                        }
                    );
                    console.log(d);
                },(e)=>{
                    console.log("error",e);
                },()=>{
                    console.log("finishing");
                })
            },
            choosenID(e){
                console.log(e)
                this.selectedID=e
                console.log(this.selectedID)
                return this.selectedID

            },
            /* del(e){
                const  index = this.regionData.indexOf(e)
                console.log(e)
                this.region_id=e.id
                axios_delete("/regions/"+this.region_id,{},
                    (d)=>{
                        console.log(d)
                        this.regionData.splice(index,1)
                        window.makeToast('Success','Region Deleted Successfully','success')
                    },(e)=>{
                        console.log("error",e);
                    },()=>{
                        console.log("finishing");
                    }
                );
            }, */
            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            updateRegion() {
                console.log(this.selectedID)
                axios_put('/regions/'+this.selectedID.id, this.selectedID, ()=>{
                    this.$refs['modal-delete'].hide()
                    axios_get("/regions",{},(d)=>{
                            this.regionData=d.filter(e=>{return e.country_id==this.country_id})
                            this.regionData=this.regionData.sort((a, b)=>{
                                if(a.name < b.name) return -1;
                                else return 1;
                            })
                        },(e)=>{
                            console.log("error",e);
                        },()=>{
                            console.log("finishing");
                        }
                    );
                }, (e)=>{
                    console.log('error', e)
                }, ()=>{
                    console.log('final')
                })
            },
        }
    };
</script>

<style scoped>
    .actionBut{
        margin-left:15px;
    }
</style>